<!-- Present only while a selection is being made IN THIS WIDGET. -->
<div class="emd-seltb" *ngIf="visible" role="status" aria-live="polite">
  <span class="emd-seltb-count" aria-hidden="true">{{ count }}</span>
  <span class="emd-seltb-label">{{ label }}</span>

  <div class="emd-seltb-actions">
    <button
      type="button"
      class="emd-seltb-btn emd-seltb-cancel"
      (click)="selection.cancel()"
      aria-label="Cancel selection"
      matTooltip="Cancel selection"
      matTooltipClass="emd-tip-mat"
    >
      <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
        <path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" />
      </svg>
    </button>

    <button
      type="button"
      class="emd-seltb-btn emd-seltb-confirm"
      (click)="selection.confirm()"
      aria-label="Confirm selection"
      matTooltip="Confirm selection"
      matTooltipClass="emd-tip-mat"
    >
      <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
        <path d="M5 12.5l4.5 4.5L19 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
  </div>
</div>
